/*
* 2007-2016 PrestaShop
*
* NOTICE OF LICENSE
*
* This source file is subject to the Academic Free License (AFL 3.0)
* that is bundled with this package in the file LICENSE.txt.
* It is also available through the world-wide-web at this URL:
* http://opensource.org/licenses/afl-3.0.php
* If you did not receive a copy of the license and are unable to
* obtain it through the world-wide-web, please send an email
* to license@prestashop.com so we can send you a copy immediately.
*
* DISCLAIMER
*
* Do not edit or add to this file if you wish to upgrade PrestaShop to newer
* versions in the future. If you wish to customize PrestaShop for your
* needs please refer to http://www.prestashop.com for more information.
*
*  @author PrestaShop SA <contact@prestashop.com>
*  @copyright  2007-2016 PrestaShop SA
*  @license    http://opensource.org/licenses/afl-3.0.php  Academic Free License (AFL 3.0)
*  International Registered Trademark & Property of PrestaShop SA
*/
function initOrder() {

	function updateCarrierList(json)
	{
		var html = json.carrier_block;
		$('#carrier_area').replaceWith(html);
		bindInputs();
		/* update hooks for carrier module */
		$('#HOOK_BEFORECARRIER').html(json.HOOK_BEFORECARRIER);

		$('#opc_delivery_methods .warning:first').hide();
	}

	function updatePaymentMethods(json)
	{
		$('#HOOK_TOP_PAYMENT').html(json.HOOK_TOP_PAYMENT);
		$('#opc_payment_methods-content #HOOK_PAYMENT').html(json.HOOK_PAYMENT);
	}

	function updatePaymentMethodsDisplay()
	{
		var checked = '';
		if ($('#cgv:checked').length !== 0)
			checked = 1;
		else
			checked = 0;
		$('#opc_payment_methods-overlay').fadeIn('slow', function(){
			$.ajax({
				type: 'POST',
				headers: { "cache-control": "no-cache" },
				url: orderOpcUrl + '?rand=' + new Date().getTime(),
				async: true,
				cache: false,
				dataType : "json",
				data: 'ajax=true&method=updateTOSStatusAndGetPayments&checked=' + checked + '&token=' + static_token,
				success: function(json)
				{
					updatePaymentMethods(json);
					if (typeof bindUniform !=='undefined')
						bindUniform();
				}
			});
			$(this).fadeOut('slow');
		});
	}

	function updateAddressSelection(is_adv_api)
	{
		var idAddress_delivery = ($('#opc_id_address_delivery').length == 1 ? $('#opc_id_address_delivery').val() : $('#id_address_delivery').val());
		var idAddress_invoice = ($('#opc_id_address_invoice').length == 1 ? $('#opc_id_address_invoice').val() : ($('#addressesAreEquals:checked').length == 1 ? idAddress_delivery : ($('#id_address_invoice').length == 1 ? $('#id_address_invoice').val() : idAddress_delivery)));

		$('#opc_account-overlay').fadeIn('slow');
		$('#opc_delivery_methods-overlay').fadeIn('slow');
		$('#opc_payment_methods-overlay').fadeIn('slow');

		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: orderOpcUrl + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "json",
			data: 'allow_refresh=1&ajax=true&method=updateAddressesSelected&id_address_delivery=' + idAddress_delivery +
	              '&id_address_invoice=' + idAddress_invoice + '&token=' + static_token +
	              (is_adv_api ? '&isAdvApi=1' : ''),
			success: function(jsonData)
			{
				if (jsonData.hasError)
				{
					var errors = '';
					for(var error in jsonData.errors)
						//IE6 bug fix
						if(error !== 'indexOf')
							errors += $('<div />').html(jsonData.errors[error]).text() + "\n";
		            if (!!$.prototype.fancybox)
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + errors + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            else
		                alert(errors);
				}
				else
				{
					if (jsonData.refresh)
					{
						location.reload();
						return;
					}
					// Update all product keys with the new address id
					$('#cart_summary .address_' + deliveryAddress).each(function() {
						$(this)
							.removeClass('address_' + deliveryAddress)
							.addClass('address_' + idAddress_delivery);
						$(this).attr('id', $(this).attr('id').replace(/_\d+$/, '_' + idAddress_delivery));
						if ($(this).find('.cart_unit ul').length > 0 && $(this).find('.cart_unit ul').attr('id').length > 0)
							$(this).find('.cart_unit ul').attr('id', $(this).find('.cart_unit ul').attr('id').replace(/_\d+$/, '_' + idAddress_delivery));

						if ($(this).find('.cart_total span').length > 0 && $(this).find('.cart_total span').attr('id').length > 0)
							$(this).find('.cart_total span').attr('id', $(this).find('.cart_total span').attr('id').replace(/_\d+$/, '_' + idAddress_delivery));

						if ($(this).find('.cart_quantity_input').length > 0 && $(this).find('.cart_quantity_input').attr('name').length > 0)
						{
							var name = $(this).find('.cart_quantity_input').attr('name')+'_hidden';

							$(this).find('.cart_quantity_input').attr('name', $(this).find('.cart_quantity_input').attr('name').replace(/_\d+$/, '_' + idAddress_delivery));
							if ($(this).find('[name="' + name + '"]').length > 0)
								$(this).find('[name="' + name + '"]').attr('name', name.replace(/_\d+_hidden$/, '_' + idAddress_delivery + '_hidden'));
						}

						if ($(this).find('.cart_quantity_delete').length > 0 && $(this).find('.cart_quantity_delete').attr('id').length > 0)
						{
							$(this).find('.cart_quantity_delete')
								.attr('id', $(this).find('.cart_quantity_delete').attr('id').replace(/_\d+$/, '_' + idAddress_delivery))
								.attr('href', $(this).find('.cart_quantity_delete').attr('href').replace(/id_address_delivery=\d+&/, 'id_address_delivery=' + idAddress_delivery+'&'));
						}

						if ($(this).find('.cart_quantity_down').length > 0 && $(this).find('.cart_quantity_down').attr('id').length > 0)
						{
							$(this).find('.cart_quantity_down')
								.attr('id', $(this).find('.cart_quantity_down').attr('id').replace(/_\d+$/, '_' + idAddress_delivery))
								.attr('href', $(this).find('.cart_quantity_down').attr('href').replace(/id_address_delivery=\d+&/, 'id_address_delivery=' + idAddress_delivery+'&'));
						}

						if ($(this).find('.cart_quantity_up').length > 0 && $(this).find('.cart_quantity_up').attr('id').length > 0)
						{
							$(this).find('.cart_quantity_up')
								.attr('id', $(this).find('.cart_quantity_up').attr('id').replace(/_\d+$/, '_' + idAddress_delivery))
								.attr('href', $(this).find('.cart_quantity_up').attr('href').replace(/id_address_delivery=\d+&/, 'id_address_delivery=' + idAddress_delivery+'&'));
						}
					});

					// Update global var deliveryAddress
					deliveryAddress = idAddress_delivery;
					if (window.ajaxCart !== undefined)
					{
						$('.cart_block_list dd, .cart_block_list dt').each(function(){
							if (typeof($(this).attr('id')) != 'undefined')
								$(this).attr('id', $(this).attr('id').replace(/_\d+$/, '_' + idAddress_delivery));
						});
					}
					updateCarrierList(jsonData.carrier_data);
					updatePaymentMethods(jsonData);
					updateCartSummary(jsonData.summary);
					updateHookShoppingCart(jsonData.HOOK_SHOPPING_CART);
					updateHookShoppingCartExtra(jsonData.HOOK_SHOPPING_CART_EXTRA);
					if ($('#gift-price').length == 1)
						$('#gift-price').html(jsonData.gift_price);
					$('#opc_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
				}
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				if (textStatus !== 'abort')
				{
					error = "TECHNICAL ERROR: unable to save adresses \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
		            if (!!$.prototype.fancybox)
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + error + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            else
		                alert(error);
				}
				$('#opc_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
			}
		});
	}

	function getCarrierListAndUpdate()
	{
		$('#opc_delivery_methods-overlay').fadeIn('slow');
		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: orderOpcUrl + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "json",
			data: 'ajax=true&method=getCarrierList&token=' + static_token,
			success: function(jsonData)
			{
				if (jsonData.hasError)
				{
					var errors = '';
					for(var error in jsonData.errors)
						//IE6 bug fix
						if(error !== 'indexOf')
							errors += $('<div />').html(jsonData.errors[error]).text() + "\n";
		            if (!!$.prototype.fancybox)
		            {
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + errors + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            }
		            else
					{
			            if (!!$.prototype.fancybox)
			                $.fancybox.open([
			                    {
			                        type: 'inline',
			                        autoScale: true,
			                        minHeight: 30,
			                        content: '<p class="fancybox-error">' + errors + '</p>'
			                    }
			                ], {
			                    padding: 0
			                });
			            else
			                alert(errors);
					}
				}
				else
					updateCarrierList(jsonData);
				$('#opc_delivery_methods-overlay').fadeOut('slow');
			}
		});
	}

	function updateCarrierSelectionAndGift()
	{
		var recyclablePackage = 0;
		var gift = 0;
		var giftMessage = '';

		var delivery_option_radio = $('.delivery_option_radio');
		var delivery_option_params = '&';
		$.each(delivery_option_radio, function(i) {
			if ($(this).prop('checked'))
				delivery_option_params += $(delivery_option_radio[i]).attr('name') + '=' + $(delivery_option_radio[i]).val() + '&';
		});
		if (delivery_option_params == '&')
			delivery_option_params = '&delivery_option=&';

		if ($('input#recyclable:checked').length)
			recyclablePackage = 1;
		if ($('input#gift:checked').length)
		{
			gift = 1;
			giftMessage = encodeURIComponent($('#gift_message').val());
		}

		$('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: orderOpcUrl + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "json",
			data: 'ajax=true&method=updateCarrierAndGetPayments' + delivery_option_params + 'recyclable=' + recyclablePackage + '&gift=' + gift + '&gift_message=' + giftMessage + '&token=' + static_token ,
			success: function(jsonData)
			{
				if (jsonData.hasError)
				{
					var errors = '';
					for(var error in jsonData.errors)
						//IE6 bug fix
						if(error !== 'indexOf')
							errors += $('<div />').html(jsonData.errors[error]).text() + "\n";
		            if (!!$.prototype.fancybox)
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + errors + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            else
		                alert(errors);
				}
				else
				{
					updateCartSummary(jsonData.summary);
					updatePaymentMethods(jsonData);
					updateHookShoppingCart(jsonData.summary.HOOK_SHOPPING_CART);
					updateHookShoppingCartExtra(jsonData.summary.HOOK_SHOPPING_CART_EXTRA);
					updateCarrierList(jsonData.carrier_data);
					$('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
					refreshDeliveryOptions();
					if (typeof bindUniform !=='undefined')
						bindUniform();
				}
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				if (textStatus !== 'abort')
					alert("TECHNICAL ERROR: unable to save carrier \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
				$('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
			}
		});
	}

	function confirmFreeOrder()
	{
		if ($('#opc_new_account-overlay').length !== 0)
			$('#opc_new_account-overlay').fadeIn('slow');
		else
			$('#opc_account-overlay').fadeIn('slow');
		$('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
		$('#confirmOrder').prop('disabled', 'disabled');
		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: orderOpcUrl + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "html",
			data: 'ajax=true&method=makeFreeOrder&token=' + static_token ,
			success: function(html)
			{
				$('#confirmOrder').prop('disabled', false);
				var array_split = html.split(':');
				if (array_split[0] == 'freeorder')
				{
					if (isGuest)
						document.location.href = guestTrackingUrl+'?id_order='+encodeURIComponent(array_split[1])+'&email='+encodeURIComponent(array_split[2]);
					else
						document.location.href = historyUrl;
				}
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				if (textStatus !== 'abort')
				{
					error = "TECHNICAL ERROR: unable to confirm the order \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
		            if (!!$.prototype.fancybox)
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + error + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            else
		                alert(error);
				}
			}
		});
	}

	function saveAddress(type)
	{
		if (type !== 'delivery' && type !== 'invoice')
			return false;

		var params = 'firstname=' + encodeURIComponent($('#firstname' + (type == 'invoice' ? '_invoice' : '')).val()) + '&lastname=' + encodeURIComponent($('#lastname' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#company' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'company=' + encodeURIComponent($('#company' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#vat_number' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'vat_number='+encodeURIComponent($('#vat_number' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#dni' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'dni=' + encodeURIComponent($('#dni' + (type == 'invoice' ? '_invoice' : '')).val())+'&';
		if ($('#address1' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'address1=' + encodeURIComponent($('#address1' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#address2' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'address2=' + encodeURIComponent($('#address2' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#postcode' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'postcode=' + encodeURIComponent($('#postcode' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#city' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'city=' + encodeURIComponent($('#city' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#id_country' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'id_country=' + parseInt($('#id_country' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#id_state' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'id_state=' + encodeURIComponent($('#id_state' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#other' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'other=' + encodeURIComponent($('#other' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#phone' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'phone=' + encodeURIComponent($('#phone' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#phone_mobile' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'phone_mobile=' + encodeURIComponent($('#phone_mobile' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if ($('#alias' + (type == 'invoice' ? '_invoice' : '')).length)
			params += 'alias=' + encodeURIComponent($('#alias' + (type == 'invoice' ? '_invoice' : '')).val()) + '&';
		if (type == 'delivery' && $('#opc_id_address_delivery').val() != undefined && parseInt($('#opc_id_address_delivery').val()) > 0)
			params += 'opc_id_address_delivery=' + parseInt($('#opc_id_address_delivery').val()) + '&';
		if (type == 'invoice' && $('#opc_id_address_invoice').val() != undefined && parseInt($('#opc_id_address_invoice').val()) > 0)
			params += 'opc_id_address_invoice=' + parseInt($('#opc_id_address_invoice').val()) + '&';
		// Clean the last &
		params = params.substr(0, params.length-1);

		var result = false;

		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: addressUrl + '?rand=' + new Date().getTime(),
			async: false,
			cache: false,
			dataType : "json",
			data: 'ajax=true&submitAddress=true&type='+type+'&'+params+'&token=' + static_token,
			success: function(jsonData)
			{
				if (jsonData.hasError)
				{
					var tmp = '';
					var i = 0;
					for(var error in jsonData.errors)
						//IE6 bug fix
						if(error !== 'indexOf')
						{
							i = i+1;
							tmp += '<li>'+jsonData.errors[error]+'</li>';
						}
					tmp += '</ol>';
					var errors = '<b>'+txtThereis+' '+i+' '+txtErrors+':</b><ol>'+tmp;
					$('#opc_account_errors').slideUp('fast', function(){
						$(this).html(errors).slideDown('slow', function(){
							//$.scrollTo('#opc_account_errors', 800);
							$("html, body").animate({ scrollTop: $('#opc_account_errors').offset().top });
						});
					});
					$('#opc_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
					result = false;
				}
				else
				{
					// update addresses id
					$('input#opc_id_address_delivery').val(jsonData.id_address_delivery);
					$('input#opc_id_address_invoice').val(jsonData.id_address_invoice);
					result = true;
				}
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				if (textStatus !== 'abort')
				{
					error = "TECHNICAL ERROR: unable to save adresses \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
		            if (!!$.prototype.fancybox)
		                $.fancybox.open([
		                    {
		                        type: 'inline',
		                        autoScale: true,
		                        minHeight: 30,
		                        content: '<p class="fancybox-error">' + error + '</p>'
		                    }
		                ], {
		                    padding: 0
		                });
		            else
		                alert(error);
				}
				$('#opc_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
			}
			});

		return result;
	}

	function updateNewAccountToAddressBlock(is_adv_api)
	{
		$('#opc_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');

		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: orderOpcUrl + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "json",
			data: 'ajax=true&method=getAddressBlockAndCarriersAndPayments&token=' + static_token +
	              (is_adv_api ? '&isAdvApi=1' : '') ,
			success: function(json)
			{
				if (json.hasError)
				{
					var errors = '';
					for(var error in json.errors)
						//IE6 bug fix
						if(error !== 'indexOf')
							errors += $('<div />').html(json.errors[error]).text() + "\n";
					alert(errors);
				}
				else
				{
					isLogged = 1;
					if (json.no_address == 1)
						document.location.href = addressUrl;

					$('#opc_new_account').fadeOut('fast', function() {
						if (typeof json.formatedAddressFieldsValuesList !== 'undefined' && json.formatedAddressFieldsValuesList )
							formatedAddressFieldsValuesList = json.formatedAddressFieldsValuesList;
						if (typeof json.order_opc_adress !== 'undefined' && json.order_opc_adress)
							$('#opc_new_account').html(json.order_opc_adress);
						// update block user info

						// 1.5 template
						if (json.block_user_info !== '' && $('#header_user').length == 1)
						{
							var elt = $(json.block_user_info).find('#header_user_info').html();
							$('#header_user_info').fadeOut('normal', function() {
								$(this).html(elt).fadeIn();
							});
						}

						// 1.6 temmplate
						if (json.block_user_info_nav !== '' && $('.header_user_info').length == 1)
						{
							$('.header_user_info').fadeOut('normal', function() {
								$(this).html(json.block_user_info_nav).fadeIn();
							});
						}

						$(this).fadeIn('fast', function() {
	                        if ($('#gift-price').length == 1)
	                            $('#gift-price').html(json.gift_price);

							//After login, the products are automatically associated to an address
							$.each(json.summary.products, function() {
								updateAddressId(this.id_product, this.id_product_attribute, '0', this.id_address_delivery);
							});
							updateAddressesDisplay(true);
	                        if (typeof is_adv_api === 'undefined' || !is_adv_api) {
	                            updateCarrierList(json.carrier_data);
	                            updateCarrierSelectionAndGift();
	                            updatePaymentMethods(json);
	                        }
	                        $('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
						});
					});
				}
			},
			error: function(XMLHttpRequest, textStatus, errorThrown) {
				if (textStatus !== 'abort')
					alert("TECHNICAL ERROR: unable to send login informations \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
				$('#opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeOut('slow');
			}
		});
	}

	//update the display of the addresses
	function updateAddressesDisplay(first_view)
	{
		// update content of delivery address
		updateAddressDisplay('delivery');
		var txtInvoiceTitle = "";
		try{
			var adrs_titles = getAddressesTitles();
			txtInvoiceTitle = adrs_titles.invoice;
		}
		catch (e)
		{}
		// update content of invoice address
		//if addresses have to be equals...
		if ($('#addressesAreEquals:checked').length === 1 && ($('#multishipping_mode_checkbox:checked').length === 0))
		{
			if ($('#multishipping_mode_checkbox:checked').length === 0) {
				$('#address_invoice_form:visible').hide('fast');
			}
			$('ul#address_invoice').html($('ul#address_delivery').html());
			$('ul#address_invoice li.address_title').html(txtInvoiceTitle);
		}
		else
		{
			$('#address_invoice_form:hidden').show('fast');
			if ($('#id_address_invoice').val())
				updateAddressDisplay('invoice');
			else
			{
				$('ul#address_invoice').html($('ul#address_delivery').html());
				$('ul#address_invoice li.address_title').html(txtInvoiceTitle);
			}
		}
		if(!first_view)
		{
			if (orderProcess === 'order')
				updateAddresses();
		}
		return true;
	}


	function updateAddressDisplay(addressType)
	{
		if (typeof formatedAddressFieldsValuesList == 'undefined' || formatedAddressFieldsValuesList.length <= 0)
			return;

		var idAddress = parseInt($('#id_address_' + addressType + '').val());
		buildAddressBlock(idAddress, addressType, $('#address_' + addressType));

		// change update link
		var link = $('ul#address_' + addressType + ' li.address_update a').attr('href');
		var expression = /id_address=\d+/;
		if (link)
		{
			link = link.replace(expression, 'id_address=' + idAddress);
			$('ul#address_' + addressType + ' li.address_update a').attr('href', link);
		}
	}

	function getAddressesTitles()
	{
		if( typeof isPro !== 'undefined' && isPro)
			return {
				'invoice': titleInvoicePro,
				'delivery': titleDeliveryPro
			};

		if (typeof titleInvoice !== 'undefined' && typeof titleDelivery !== 'undefined')
			return {
				'invoice': titleInvoice,
				'delivery': titleDelivery
			};
		else
			return {
				'invoice': '',
				'delivery': ''
			};
	}

	function buildAddressBlock(id_address, address_type, dest_comp)
	{
		if (isNaN(id_address))
			return;
		var adr_titles_vals = getAddressesTitles();
		var li_content = formatedAddressFieldsValuesList[id_address]['formated_fields_values'];
		var ordered_fields_name = ['title'];
		var reg = new RegExp("[ ]+", "g");
		ordered_fields_name = ordered_fields_name.concat(formatedAddressFieldsValuesList[id_address]['ordered_fields']);
		ordered_fields_name = ordered_fields_name.concat(['update']);
		dest_comp.html('');
		li_content['title'] = adr_titles_vals[address_type];
		if (typeof liUpdate !== 'undefined')
		{
			var items = liUpdate.split(reg);
			var regUrl = new RegExp('(https?://[^"]*)', 'gi');
			liUpdate = liUpdate.replace(regUrl, addressUrlAdd + parseInt(id_address));
			li_content['update'] = liUpdate;
		}
		appendAddressList(dest_comp, li_content, ordered_fields_name);
	}

	function appendAddressList(dest_comp, values, fields_name)
	{
		for (var item in fields_name)
		{
			var name = fields_name[item].replace(/,/g, "");
			var value = getFieldValue(name, values);
			if (value != "")
			{
				var new_li = document.createElement('li');
				var reg = new RegExp("[ ]+", "g");
				var classes = name.split(reg);
				new_li.className = '';
				for (clas in classes)
					new_li.className += 'address_' + classes[clas].toLowerCase().replace(":", "_") + ' ';
				new_li.className = $.trim(new_li.className);
				new_li.innerHTML = value;
				dest_comp.append(new_li);
			}
		}
	}

	function getFieldValue(field_name, values)
	{
		var reg = new RegExp("[ ]+", "g");
		var items = field_name.split(reg);
		var vals = new Array();
		for (var field_item in items)
		{
			items[field_item] = items[field_item].replace(/,/g, "");
			vals.push(values[items[field_item]]);
		}
		return vals.join(" ");
	}

	function bindInputs()
	{
		// Order message update
		$('#message').blur(function() {
			$('#opc_delivery_methods-overlay').fadeIn('slow');
			$.ajax({
				type: 'POST',
				headers: { "cache-control": "no-cache" },
				url: orderOpcUrl + '?rand=' + new Date().getTime(),
				async: false,
				cache: false,
				dataType : "json",
				data: 'ajax=true&method=updateMessage&message=' + encodeURIComponent($('#message').val()) + '&token=' + static_token ,
				success: function(jsonData)
				{
					if (jsonData.hasError)
					{
						var errors = '';
						for(var error in jsonData.errors)
							//IE6 bug fix
							if(error !== 'indexOf')
								errors += $('<div />').html(jsonData.errors[error]).text() + "\n";
						alert(errors);
					}
				else
					$('#opc_delivery_methods-overlay').fadeOut('slow');
				},
				error: function(XMLHttpRequest, textStatus, errorThrown) {
					if (textStatus !== 'abort')
						alert("TECHNICAL ERROR: unable to save message \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus);
					$('#opc_delivery_methods-overlay').fadeOut('slow');
				}
			});
			if (typeof bindUniform !=='undefined')
				bindUniform();
		});

		// Recyclable checkbox
		$('#recyclable').on('click', function(e){
			updateCarrierSelectionAndGift();
		});

		// Gift checkbox update
		$('#gift').off('click').on('click', function(e){
			if ($('#gift').is(':checked'))
				$('#gift_div').show();
			else
				$('#gift_div').hide();
			updateCarrierSelectionAndGift();
		});

		if ($('#gift').is(':checked'))
			$('#gift_div').show();
		else
			$('#gift_div').hide();

		// Gift message update
		$('#gift_message').on('change', function() {
			updateCarrierSelectionAndGift();
		});

		// Term Of Service (TOS)
		$('#cgv').on('click', function(e){
			updatePaymentMethodsDisplay();
		});
	}

	function multishippingMode(it)
	{
		if ($(it).prop('checked'))
		{
			$('#address_delivery, .address_delivery').hide();
			$('#address_delivery, .address_delivery').parent().hide();
			$('#address_invoice').removeClass('alternate_item').addClass('item');
			$('#multishipping_mode_box').addClass('on');
			$('.addressesAreEquals').hide();
			$('#address_invoice_form').show();

			$(document).on('click', '#link_multishipping_form', function(e){e.preventDefault();});
			$('.address_add a').attr('href', addressMultishippingUrl);

			$(document).on('click', '#link_multishipping_form', function(e){
				if(!!$.prototype.fancybox)
					$.fancybox({
						'openEffect': 'elastic',
						'closeEffect': 'elastic',
						'type': 'ajax',
						'href':     this.href,
						'beforeClose': function(){
							// Reload the cart
							$.ajax({
								type: 'POST',
								headers: { "cache-control": "no-cache" },
								url: orderOpcUrl + '?rand=' + new Date().getTime(),
								data: 'ajax=true&method=cartReload',
								dataType : 'html',
								cache: false,
								success: function(data) {
									$('#cart_summary').replaceWith($(data).find('#cart_summary'));
									$('.cart_quantity_input').typeWatch({ highlight: true, wait: 600, captureLength: 0, callback: function(val) { updateQty(val, true, this.el); } });
								}
							});
							updateCarrierSelectionAndGift();
						},
						'beforeLoad': function(){
							// Removing all ids on the cart to avoid conflic with the new one on the fancybox
							// This action could "break" the cart design, if css rules use ids of the cart
							$.each($('#cart_summary *'), function(it, el) {
								$(el).attr('id', '');
							});
						},
						'afterLoad': function(){
							$('.fancybox-inner .cart_quantity_input').typeWatch({ highlight: true, wait: 600, captureLength: 0, callback: function(val) { updateQty(val, false, this.el);} });
							cleanSelectAddressDelivery();
							$('.fancybox-outer').append($('<div class="multishipping_close_container"><a id="multishipping-close" class="btn btn-default button button-small" href="#"><span>'+CloseTxt+'</span></a></div>'));
							$(document).on('click', '#multishipping-close', function(e){
								var newTotalQty = 0;
								$('.fancybox-inner .cart_quantity_input').each(function(){
									newTotalQty += parseInt($(this).val());
								});
								if (newTotalQty !== totalQty) {
									if(!confirm(QtyChanged)) {
										return false;
									}
								}
								$.fancybox.close();
								return false;
							});
							totalQty = 0;
							$('.fancybox-inner .cart_quantity_input').each(function(){
								totalQty += parseInt($(this).val());
							});
						}
					});
			});
		}
		else
		{
			$('#address_delivery, .address_delivery').show();
			$('#address_invoice').removeClass('item').addClass('alternate_item');
			$('#multishipping_mode_box').removeClass('on');
			$('.addressesAreEquals').show();
			if ($('.addressesAreEquals').find('input:checked').length)
				$('#address_invoice_form').hide();
			else
				$('#address_invoice_form').show();
			$('.address_add a').attr('href', addressUrl);

			// Disable multi address shipping
			$.ajax({
				type: 'POST',
				headers: { "cache-control": "no-cache" },
				url: orderOpcUrl + '?rand=' + new Date().getTime(),
				async: true,
				cache: false,
				data: 'ajax=true&method=noMultiAddressDelivery'
			});

			// Reload the cart
			$.ajax({
				type: 'POST',
				headers: { "cache-control": "no-cache" },
				url: orderOpcUrl + '?rand=' + new Date().getTime(),
				async: true,
				cache: false,
				data: 'ajax=true&method=cartReload',
				dataType : 'html',
				success: function(data) {
					$('#cart_summary').replaceWith($(data).find('#cart_summary'));
				}
			});
		}
		if (typeof bindUniform !=='undefined')
			bindUniform();
	}

	function updateAddressId(id_product, id_product_attribute, old_id_address_delivery, id_address_delivery, line)
	{
		if (typeof(line) == 'undefined' || line.length == 0)
			line = $('#cart_summary tr[id^=product_' + id_product + '_' + id_product_attribute + '_0_], #cart_summary tr[id^=product_' + id_product + '_' + id_product_attribute + '_nocustom_]');

		$('.product_customization_for_' + id_product + '_' + id_product_attribute + '_' + old_id_address_delivery).each(function(){
			$(this).attr('id', $(this).attr('id').replace(/_\d+$/, '_' + id_address_delivery)).removeClass('product_customization_for_' + id_product + '_' + id_product_attribute + '_' + old_id_address_delivery + ' address_' + old_id_address_delivery).addClass('product_customization_for_' + id_product + '_' + id_product_attribute + '_' + id_address_delivery + ' address_' + id_address_delivery);
			$(this).find('input[name^=quantity_]').each(function(){
				if (typeof($(this).attr('name')) != 'undefined')
					$(this).attr('name', $(this).attr('name').replace(/_\d+(_hidden|)$/, '_' + id_address_delivery));
			});
			$(this).find('a').each(function(){
				if (typeof($(this).attr('href')) != 'undefined')
					$(this).attr('href', $(this).attr('href').replace(/id_address_delivery=\d+/, 'id_address_delivery=' + id_address_delivery));
			});
		});

		line.attr('id', line.attr('id').replace(/_\d+$/, '_' + id_address_delivery)).removeClass('address_' + old_id_address_delivery).addClass('address_' + id_address_delivery).find('span[id^=cart_quantity_custom_], span[id^=total_product_price_], input[name^=quantity_], .cart_quantity_down, .cart_quantity_up, .cart_quantity_delete').each(function(){

			if (typeof($(this).attr('name')) != 'undefined')
				$(this).attr('name', $(this).attr('name').replace(/_\d+(_hidden|)$/, '_' + id_address_delivery));
			if (typeof($(this).attr('id')) != 'undefined')
				$(this).attr('id', $(this).attr('id').replace(/_\d+$/, '_' + id_address_delivery));
			if (typeof($(this).attr('href')) != 'undefined')
				$(this).attr('href', $(this).attr('href').replace(/id_address_delivery=\d+/, 'id_address_delivery=' + id_address_delivery));
		});

		line.find('#select_address_delivery_' + id_product + '_' + id_product_attribute + '_' + old_id_address_delivery).attr('id', 'select_address_delivery_' + id_product + '_' + id_product_attribute + '_' + id_address_delivery);

		if (window.ajaxCart !== undefined)
		{
			$('.cart_block_list dd, .cart_block_list dt').each(function(){
				if (typeof($(this).attr('id')) != 'undefined')
					$(this).attr('id', $(this).attr('id').replace(/_\d+$/, '_' + id_address_delivery));
			});
		}
	}

	function updateCartSummary(json)
	{
		var i;
		var nbrProducts = 0;
		var product_list = new Array();

		if (typeof json == 'undefined')
			return;

		$('div.alert-danger').fadeOut();

		for (i=0;i<json.products.length;i++)
			product_list[json.products[i].id_product + '_' + json.products[i].id_product_attribute + '_' + json.products[i].id_address_delivery] = json.products[i];

		if (!$('.multishipping-cart:visible').length)
		{
			for (i=0;i<json.gift_products.length;i++)
				if (typeof(product_list[json.gift_products[i].id_product + '_' + json.gift_products[i].id_product_attribute + '_' + json.gift_products[i].id_address_delivery]) !== 'undefined')
					product_list[json.gift_products[i].id_product + '_' + json.gift_products[i].id_product_attribute + '_' + json.gift_products[i].id_address_delivery].quantity -= json.gift_products[i].cart_quantity;
		}
		else
			for (i=0;i<json.gift_products.length;i++)
				if (typeof(product_list[json.gift_products[i].id_product + '_' + json.gift_products[i].id_product_attribute + '_' + json.gift_products[i].id_address_delivery]) == 'undefined')
					product_list[json.gift_products[i].id_product + '_' + json.gift_products[i].id_product_attribute + '_' + json.gift_products[i].id_address_delivery] = json.gift_products[i];

		for (i in product_list)
		{
			// if reduction, we need to show it in the cart by showing the initial price above the current one
			var reduction = product_list[i].reduction_applies;
			var reduction_type = product_list[i].reduction_type;
			var reduction_symbol = '';
			var initial_price_text = '';
			var initial_price = '';

			if (typeof(product_list[i].price_without_quantity_discount) !== 'undefined')
				initial_price = formatCurrency(product_list[i].price_without_quantity_discount, currencyFormat, currencySign, currencyBlank);

			var current_price = '';
			var product_total = '';
			var product_customization_total = '';

			if (priceDisplayMethod !== 0)
			{
				current_price = formatCurrency(product_list[i].price, currencyFormat, currencySign, currencyBlank);
				product_total = product_list[i].total;
				product_customization_total = product_list[i].total_customization;
			}
			else
			{
				current_price = formatCurrency(product_list[i].price_wt, currencyFormat, currencySign, currencyBlank);
				product_total = product_list[i].total_wt;
				product_customization_total = product_list[i].total_customization_wt;
			}

			var current_price_class ='price';
			var price_reduction = '';
			if (reduction && typeof(initial_price) !== 'undefined')
			{
				if (reduction_type == 'amount')
					price_reduction = product_list[i].reduction_formatted;
				else
				{
					var display_price = 0;
					if (priceDisplayMethod !== 0)
						display_price = product_list[i].price;
					else
						display_price = product_list[i].price_wt;

					price_reduction = ps_round((product_list[i].price_without_quantity_discount - display_price)/product_list[i].price_without_quantity_discount * -100);
					reduction_symbol = '%';
				}

				if (initial_price !== '' && product_list[i].price_without_quantity_discount > product_list[i].price)
				{
					initial_price_text = '<li class="price-percent-reduction small">&nbsp;'+price_reduction+reduction_symbol+'&nbsp;</li><li class="old-price">' + initial_price + '</li>';
					current_price_class += ' special-price';
				}
			}

			var key_for_blockcart = product_list[i].id_product + '_' + product_list[i].id_product_attribute + '_' + product_list[i].id_address_delivery;
			var key_for_blockcart_nocustom = product_list[i].id_product + '_' + product_list[i].id_product_attribute + '_' + ((product_list[i].id_customization && product_list[i].quantity_without_customization != product_list[i].quantity)? 'nocustom' : '0') + '_' + product_list[i].id_address_delivery;

			$('#product_price_' + key_for_blockcart).html('<li class="' + current_price_class + '">' + current_price + '</li>' + initial_price_text);
			if (typeof(product_list[i].customizationQuantityTotal) !== 'undefined' && product_list[i].customizationQuantityTotal > 0)
				$('#total_product_price_' + key_for_blockcart).html(formatCurrency(product_customization_total, currencyFormat, currencySign, currencyBlank));
			else
				$('#total_product_price_' + key_for_blockcart).html(formatCurrency(product_total, currencyFormat, currencySign, currencyBlank));
			if (product_list[i].quantity_without_customization != product_list[i].quantity)
				$('#total_product_price_' + key_for_blockcart_nocustom).html(formatCurrency(product_total, currencyFormat, currencySign, currencyBlank));

			$('input[name=quantity_' + key_for_blockcart_nocustom + ']').val(product_list[i].id_customization? product_list[i].quantity_without_customization : product_list[i].cart_quantity);
			$('input[name=quantity_' + key_for_blockcart_nocustom + '_hidden]').val(product_list[i].id_customization? product_list[i].quantity_without_customization : product_list[i].cart_quantity);
			if (typeof(product_list[i].customizationQuantityTotal) !== 'undefined' && product_list[i].customizationQuantityTotal > 0)
				$('#cart_quantity_custom_' + key_for_blockcart).html(product_list[i].customizationQuantityTotal);
			nbrProducts += parseInt(product_list[i].quantity);
		}

		// Update discounts
		var discount_count = 0;
		for(var e in json.discounts)
		{
			discount_count++;
			break;
		}

		if (!discount_count)
		{
			$('.cart_discount').each(function(){$(this).remove();});
			$('.cart_total_voucher').remove();
		}
		else
		{
			if ($('.cart_discount').length == 0)
			{
				location.reload();
				return;
			}

			if (priceDisplayMethod !== 0)
				$('#total_discount').html('-' + formatCurrency(json.total_discounts_tax_exc, currencyFormat, currencySign, currencyBlank));
			else
				$('#total_discount').html('-' + formatCurrency(json.total_discounts, currencyFormat, currencySign, currencyBlank));

			$('.cart_discount').each(function(){
				var idElmt = $(this).attr('id').replace('cart_discount_','');
				var toDelete = true;

				for (var i in json.discounts)
					if (json.discounts[i].id_discount == idElmt)
					{
						if (json.discounts[i].value_real !== '!')
						{
							if (priceDisplayMethod !== 0)
								$('#cart_discount_' + idElmt + ' td.cart_discount_price span.price-discount').html(formatCurrency(json.discounts[i].value_tax_exc * -1, currencyFormat, currencySign, currencyBlank));
							else
								$('#cart_discount_' + idElmt + ' td.cart_discount_price span.price-discount').html(formatCurrency(json.discounts[i].value_real * -1, currencyFormat, currencySign, currencyBlank));
						}
						toDelete = false;
					}
				if (toDelete)
					$('#cart_discount_' + idElmt + ', #cart_total_voucher').fadeTo('fast', 0, function(){ $(this).remove(); });
			});
		}

		// Block cart
		if (typeof(orderProcess) !== 'undefined' && orderProcess == 'order-opc' && !json.is_virtual_cart)
			$('.ajax_cart_shipping_cost').parent().find('.unvisible').show();

		if (json.total_shipping > 0)
		{
			if (priceDisplayMethod !== 0)
			{
				$('.cart_block_shipping_cost').html(formatCurrency(json.total_shipping_tax_exc, currencyFormat, currencySign, currencyBlank));
				$('.cart_block_wrapping_cost').html(formatCurrency(json.total_wrapping_tax_exc, currencyFormat, currencySign, currencyBlank));
				$('.cart_block_total').html(formatCurrency(json.total_price_without_tax, currencyFormat, currencySign, currencyBlank));
			}
			else
			{
				$('.cart_block_shipping_cost').html(formatCurrency(json.total_shipping, currencyFormat, currencySign, currencyBlank));
				$('.cart_block_wrapping_cost').html(formatCurrency(json.total_wrapping, currencyFormat, currencySign, currencyBlank));
				$('.cart_block_total').html(formatCurrency(json.total_price, currencyFormat, currencySign, currencyBlank));
			}
		}
		else
		{
			if (parseFloat(json.total_shipping) > 0)
				$('.ajax_cart_shipping_cost').text(jsonData.shippingCost);
			else if (json.carrier.id == null && typeof(toBeDetermined) !== 'undefined' && !json.free_ship)
				$('.ajax_cart_shipping_cost').html(toBeDetermined);
			else if (typeof(freeShippingTranslation) != 'undefined')
				$('.ajax_cart_shipping_cost').html(freeShippingTranslation);
		}

		$('.cart_block_tax_cost').html(formatCurrency(json.total_tax, currencyFormat, currencySign, currencyBlank));
		$('.ajax_cart_quantity').html(nbrProducts);

		// Cart summary
		$('#summary_products_quantity').html(nbrProducts + ' ' + (nbrProducts > 1 ? txtProducts : txtProduct));
		if (priceDisplayMethod !== 0)
			$('#total_product').html(formatCurrency(json.total_products, currencyFormat, currencySign, currencyBlank));
		else
			$('#total_product').html(formatCurrency(json.total_products_wt, currencyFormat, currencySign, currencyBlank));
		$('#total_price').html(formatCurrency(json.total_price, currencyFormat, currencySign, currencyBlank));
		$('#total_price_without_tax').html(formatCurrency(json.total_price_without_tax, currencyFormat, currencySign, currencyBlank));
		$('#total_tax').html(formatCurrency(json.total_tax, currencyFormat, currencySign, currencyBlank));

		$('.cart_total_delivery').show();
		if (json.total_shipping > 0)
		{
			if (priceDisplayMethod !== 0)
				$('#total_shipping').html(formatCurrency(json.total_shipping_tax_exc, currencyFormat, currencySign, currencyBlank));
			else
				$('#total_shipping').html(formatCurrency(json.total_shipping, currencyFormat, currencySign, currencyBlank));
		}
		else
		{
			if (json.carrier.id != null || json.free_ship)
			{
				$('#total_shipping').html(freeShippingTranslation);
				if (json.is_virtual_cart)
					$('.cart_total_delivery').hide();
			}
			if (!hasDeliveryAddress)
				$('.cart_total_delivery').hide();
		}

		if (json.total_wrapping > 0)
		{
			$('#total_wrapping').html(formatCurrency(json.total_wrapping, currencyFormat, currencySign, currencyBlank));
			$('#total_wrapping').parent().show();
		}
		else
		{
			$('#total_wrapping').html(formatCurrency(json.total_wrapping, currencyFormat, currencySign, currencyBlank));
			$('#total_wrapping').parent().hide();
		}
	}

	function updateHookShoppingCart(html)
	{
		$('#HOOK_SHOPPING_CART').html(html);
		if (typeof initCrossSellingbxSlider !== 'undefined')
			initCrossSellingbxSlider();
	}

	function updateHookShoppingCartExtra(html)
	{
		$('#HOOK_SHOPPING_CART_EXTRA').html(html);
	}

	function refreshDeliveryOptions()
	{
		$.each($('.delivery_option_radio'), function() {
			if ($(this).prop('checked'))
			{
				if ($(this).parent().find('.delivery_option_carrier.not-displayable').length == 0)
					$(this).parent().find('.delivery_option_carrier').show();
				var carrier_id_list = $(this).val().split(',');
				carrier_id_list.pop();
				var it = this;
				$(carrier_id_list).each(function() {
					$(it).closest('.delivery_options').find('input[value="' + this.toString() + '"]').change();
				});
			}
			else
				$(this).parent().find('.delivery_option_carrier').hide();
		});
	}

	function updateExtraCarrier(id_delivery_option, id_address)
	{
		var url = "";

		if(typeof(orderOpcUrl) !== 'undefined')
			url = orderOpcUrl;
		else
			url = orderUrl;

		$.ajax({
			type: 'POST',
			headers: { "cache-control": "no-cache" },
			url: url + '?rand=' + new Date().getTime(),
			async: true,
			cache: false,
			dataType : "json",
			data: 'ajax=true'
				+ '&method=updateExtraCarrier'
				+ '&id_address='+id_address
				+ '&id_delivery_option='+id_delivery_option
				+ '&token='+static_token
				+ '&allow_refresh=1',
			success: function(jsonData)
			{
				$('#HOOK_EXTRACARRIER_' + id_address).html(jsonData['content']);
			}
		});
	}

	function setCountries()
	{
		if (typeof countries !== 'undefined' && countries)
		{
			var countriesPS = [];
		    for (var i in countries)
			{
				var id_country = countries[i]['id_country'];
				if (typeof countries[i]['states'] !== 'undefined' && parseInt(countries[i]['contains_states']))
				{
					countriesPS[id_country] = [];
		    		for (var j in countries[i]['states'])
						countriesPS[parseInt(id_country)].push({'id' : parseInt(countries[i]['states'][j]['id_state']), 'name' : countries[i]['states'][j]['name']});
				}

				if (typeof countries[i]['need_identification_number'] !== 'undefined' && parseInt(countries[i]['need_identification_number']) > 0)
					countriesNeedIDNumber.push(parseInt(countries[i]['id_country']));
				if (typeof countries[i]['need_zip_code'] !== 'undefined' && parseInt(countries[i]['need_zip_code']) > 0)
					countriesNeedZipCode[parseInt(countries[i]['id_country'])] = countries[i]['zip_code_format'];
			}
		}
		states = countriesPS;
	}

	function bindCheckbox()
	{
		if ($('#invoice_address:checked').length > 0)
		{
			$('#opc_invoice_address').slideDown('slow');
			if ($('#company_invoice').val() == '')
				$('#vat_number_block_invoice').hide();
			if (typeof bindUniform !=='undefined')
				bindUniform();
		}
		else
			$('#opc_invoice_address').slideUp('slow');
	}

	function bindZipcode()
	{
		$(document).on('keyup', 'input[name^=postcode]', function(e)
		{
			var char = String.fromCharCode(e.keyCode);
			if (/[a-zA-Z]/.test(char))
				$.trim($(this).val($(this).val().toUpperCase()));
		});
	}

	function bindStateInputAndUpdate()
	{
		$('.id_state, .dni, .postcode').css({'display':'none'});
		updateState();
		updateNeedIDNumber();
		updateZipCode();

		$(document).on('change', '#id_country', function(e)
		{
			updateState();
			updateNeedIDNumber();
			updateZipCode();
			if (typeof validate_field !== 'undefined')
				validate_field('#postcode');
		});

		if ($('#id_country_invoice').length !== 0)
		{
			$(document).on('change', '#id_country_invoice', function(e)
			{
				updateState('invoice');
				updateNeedIDNumber('invoice');
				updateZipCode('invoice');
				if (typeof validate_field !== 'undefined')
					validate_field('#postcode_invoice');
			});
			updateState('invoice');
			updateNeedIDNumber('invoice');
			updateZipCode('invoice');
		}

		if (typeof idSelectedState !== 'undefined' && idSelectedState)
			$('.id_state option[value=' + idSelectedState + ']').prop('selected', true);
		if (typeof idSelectedStateInvoice !== 'undefined' && idSelectedStateInvoice)
			$('.id_state_invoice option[value=' + idSelectedStateInvoice + ']').prop('selected', true);
	}

	function updateState(suffix)
	{
		$('#id_state' + (typeof suffix !== 'undefined' ? '_' + suffix : '')+' option:not(:first-child)').remove();
		if (typeof countries !== 'undefined')
			var state_list = states[parseInt($('#id_country' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).val())];
		if (typeof state_list !== 'undefined')
		{
			$(state_list).each(function(key, item){
				$('#id_state' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).append('<option value="' + parseInt(item.id) + '">' + item.name + '</option>');
			});

			$('.id_state' + (typeof suffix !== 'undefined' ? '_' + suffix : '') + ':hidden').fadeIn('slow');
			$('#id_state, #id_state_invoice').uniform();
		}
		else
			$('.id_state' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).fadeOut('fast');
	}

	function updateNeedIDNumber(suffix)
	{
		var id_country = parseInt($('#id_country' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).val());
		if (countriesNeedIDNumber.indexOf(id_country) >= 0)
		{
			$('.dni' + (typeof suffix !== 'undefined' ? '_' + suffix : '') + ':hidden').fadeIn('slow');
			$('#dni').uniform();
		}
		else
			$('.dni' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).fadeOut('fast');
	}

	function updateZipCode(suffix)
	{
		var id_country = parseInt($('#id_country' + (typeof suffix !== 'undefined' ? '_' + suffix : '')).val());
		if (typeof countriesNeedZipCode[id_country] !== 'undefined')
		{
			$('.postcode' + (typeof suffix !== 'undefined' ? '_' + suffix : '') + ':hidden').fadeIn('slow');
			//$('#postcode').uniform();
		}
		else
			$('.postcode'+(typeof suffix !== 'undefined' ? '_' + suffix : '')).fadeOut('fast');
	}

	var countriesNeedIDNumber = [];
	var countriesNeedZipCode = [];
	var states = [];

	if( $('#order-opc').length ){

		// GUEST CHECKOUT / NEW ACCOUNT MANAGEMENT
		if ((typeof isLogged == 'undefined' || !isLogged) || (typeof isGuest !== 'undefined' && isGuest))
		{
			if (guestCheckoutEnabled && !isLogged && !isGuest)
			{
				$('#opc_account_choice').show();
				$('#opc_account_form, #opc_invoice_address').hide();

				$(document).on('click', '#opc_createAccount',function(e){
					e.preventDefault();
					$('.is_customer_param').show();
					$('#opc_account_form').slideDown('slow');
					$('#is_new_customer').val('1');
					$('#opc_account_choice, #opc_invoice_address').hide();
					if (typeof bindUniform !=='undefined')
						bindUniform();
				});
				$(document).on('click', '#opc_guestCheckout', function(e){
					e.preventDefault();
					$('.is_customer_param').hide();
					$('#opc_account_form').slideDown('slow');
					$('#is_new_customer').val('0');
					$('#opc_account_choice, #opc_invoice_address').hide();
					$('#new_account_title').html(txtInstantCheckout);
					$('#submitAccount').attr({id : 'submitGuestAccount', name : 'submitGuestAccount'});
					if (typeof bindUniform !=='undefined')
						bindUniform();
				});
			}
			else if (isGuest)
			{
				$('.is_customer_param').hide();
				$('#opc_account_form').show('slow');
				$('#is_new_customer').val('0');
				$('#opc_account_choice, #opc_invoice_address').hide();
				$('#new_account_title').html(txtInstantCheckout);
			}
			else
			{
				$('#opc_account_choice').hide();
				$('#is_new_customer').val('1');
				$('.is_customer_param, #opc_account_form').show();
				$('#opc_invoice_address').hide();
			}

			// LOGIN CONTROL
			$('#new_account_form_email').on('submit', function(e){

				e.preventDefault();
				$('#new_account_form_email .error').html('').hide();
				$.ajax({
					type: 'POST',
					url: baseUri + '?rand=' + new Date().getTime(),
					async: true,
					cache: false,
					dataType : "json",
					headers: { "cache-control": "no-cache" },
					data:
					{
						controller: 'authentication',
						SubmitCreate: 1,
						ajax: true,
						email_create: $('#email_test').val(),
						back: $('input[name=back]').val(),
						token: token
					},
					success: function(jsonData)
					{
						if (jsonData.hasError)
						{
							var errors = '';
							for(error in jsonData.errors)
								//IE6 bug fix
								if(error != 'indexOf')
									errors += '<li>' + jsonData.errors[error] + '</li>';
							$('#new_account_form_email .error').html('<ol>' + errors + '</ol>').show();
							$("html, body").animate({ scrollTop: $('#new_account_form_email').offset().top });
						}
						else
						{
							$('.opc_user_infos').slideDown();
							$('#email').val( $('#email_test').val() );
							$("html, body").animate({ scrollTop: $('.opc_user_infos').offset().top });
						}
					}
				});

			});


			// LOGIN FORM SENDING
			$(document).on('click', '#SubmitLogin', function(e){
				e.preventDefault();
	            var that = $(this);
				$.ajax({
					type: 'POST',
					headers: { "cache-control": "no-cache" },
					url: authenticationUrl + '?rand=' + new Date().getTime(),
					async: false,
					cache: false,
					dataType : "json",
					data: 'SubmitLogin=true&ajax=true&email='+encodeURIComponent($('#login_email').val())+'&passwd='+encodeURIComponent($('#login_passwd').val())+'&token=' + static_token ,
					success: function(jsonData)
					{
						if (jsonData.hasError)
						{
							var errors = '<b>'+txtThereis+' '+jsonData.errors.length+' '+txtErrors+':</b><ol>';
							for(var error in jsonData.errors)
								//IE6 bug fix
								if(error !== 'indexOf')
									errors += '<li>'+jsonData.errors[error]+'</li>';
							errors += '</ol>';
							$('#opc_login_errors').html(errors).slideDown('slow');
						}
						else
						{
							// update token
							static_token = jsonData.token;
							updateNewAccountToAddressBlock(that.attr('data-adv-api'));
						}
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						if (textStatus !== 'abort')
						{
							error = "TECHNICAL ERROR: unable to send login informations \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
				            if (!!$.prototype.fancybox)
				                $.fancybox.open([
				                    {
				                        type: 'inline',
				                        autoScale: true,
				                        minHeight: 30,
				                        content: '<p class="fancybox-error">' + error + '</p>'
				                    }
				                ], {
				                    padding: 0
				                });
				            else
				                alert(error);
						}
					}
				});
			});

			// VALIDATION / CREATION AJAX
			$(document).on('click', '#submitAccount, #submitGuestAccount', function(e){

				e.preventDefault();
				$('#opc_new_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeIn('slow')

				var callingFile = '';
	            var advApiParam = '';
	            var params = '';

	            if ($(this).attr('data-adv-api')) {
	                advApiParam = '&isAdvApi=1';
	            }

				if (parseInt($('#opc_id_customer').val()) == 0)
				{
					callingFile = authenticationUrl;
					params = 'submitAccount=true&';
				}
				else
				{
					callingFile = orderOpcUrl;
					params = 'method=editCustomer&';
				}

				$('#opc_account_form input:visible, #opc_account_form input[type=hidden]').each(function() {
					if ($(this).is('input[type=checkbox]'))
					{
						if ($(this).is(':checked'))
							params += encodeURIComponent($(this).attr('name'))+'=1&';
					}
					else if ($(this).is('input[type=radio]'))
					{
						if ($(this).is(':checked'))
							params += encodeURIComponent($(this).attr('name'))+'='+encodeURIComponent($(this).val())+'&';
					}
					else
						params += encodeURIComponent($(this).attr('name'))+'='+encodeURIComponent($(this).val())+'&';
				});

				$('#opc_account_form select:visible').each(function() {
					params += encodeURIComponent($(this).attr('name'))+'='+encodeURIComponent($(this).val())+'&';
				});
				params += 'customer_lastname='+encodeURIComponent($('#customer_lastname').val())+'&';
				params += 'customer_firstname='+encodeURIComponent($('#customer_firstname').val())+'&';
				params += 'alias='+encodeURIComponent($('#alias').val())+'&';
				params += 'other='+encodeURIComponent($('#other').val())+'&';
				params += 'is_new_customer='+encodeURIComponent($('#is_new_customer').val())+'&';
				// Clean the last &
				params = params.substr(0, params.length-1);

				$.ajax({
					type: 'POST',
					headers: { "cache-control": "no-cache" },
					url: callingFile + '?rand=' + new Date().getTime() + advApiParam,
					async: false,
					cache: false,
					dataType : "json",
					data: 'ajax=true&'+params+'&token=' + static_token ,
					success: function(jsonData)
					{
						if (jsonData.hasError)
						{
							var tmp = '';
							var i = 0;
							for(var error in jsonData.errors)
								//IE6 bug fix
								if(error !== 'indexOf')
								{
									i = i+1;
									tmp += '<li>'+jsonData.errors[error]+'</li>';
								}
							tmp += '</ol>';
							var errors = '<b>'+txtThereis+' '+i+' '+txtErrors+':</b><ol>'+tmp;
							$('#opc_account_errors').slideUp('fast', function(){
								$(this).html(errors).slideDown('slow', function(){
									//$.scrollTo('#opc_account_errors', 800);
									$("html, body").animate({ scrollTop: $('#opc_account_errors').offset().top });
								});
							});
						}
						else
						{
							$('#opc_account_errors').slideUp('slow', function(){
								$(this).html('');
							});
						}

						isGuest = parseInt($('#is_new_customer').val()) == 1 ? 0 : 1;
						// update addresses id
						if(jsonData.id_address_delivery !== undefined && jsonData.id_address_delivery > 0)
							$('#opc_id_address_delivery').val(jsonData.id_address_delivery);
						if(jsonData.id_address_invoice !== undefined && jsonData.id_address_invoice > 0)
							$('#opc_id_address_invoice').val(jsonData.id_address_invoice);

						if (jsonData.id_customer !== undefined && jsonData.id_customer !== 0 && jsonData.isSaved)
						{
							// update token
							static_token = jsonData.token;

							// It's not a new customer
							if ($('#opc_id_customer').val() !== '0')
								if (!saveAddress('delivery'))
									return false;

							// update id_customer
							$('#opc_id_customer').val(jsonData.id_customer);

							if ($('#invoice_address:checked').length !== 0)
							{
								if (!saveAddress('invoice'))
									return false;
							}

							// update id_customer
							$('#opc_id_customer').val(jsonData.id_customer);

							// force to refresh carrier list
							if (isGuest)
							{
								isLogged = 1;
								$('#opc_account_saved').fadeIn('slow');
								$('#submitAccount').hide();
								updateAddressSelection(advApiParam);
							}
							else
								updateNewAccountToAddressBlock(advApiParam);
						}
						$('#opc_new_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeIn('slow');
					},
					error: function(XMLHttpRequest, textStatus, errorThrown) {
						if (textStatus !== 'abort')
						{
							error = "TECHNICAL ERROR: unable to save account \n\nDetails:\nError thrown: " + XMLHttpRequest + "\n" + 'Text status: ' + textStatus;
				            if (!!$.prototype.fancybox)
				                $.fancybox.open([
				                    {
				                        type: 'inline',
				                        autoScale: true,
				                        minHeight: 30,
				                        content: '<p class="fancybox-error">' + error + '</p>'
				                    }
				                ], {
				                    padding: 0
				                });
				            else
				                alert(error);
						}
						$('#opc_new_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeIn('slow')
					}
				});
			});
		}

		bindInputs();

		$('#opc_account_form input,select,textarea').change(function() {
			if ($(this).is(':visible'))
			{
				$('#opc_account_saved').fadeOut('slow');
				$('#submitAccount').show();
			}
		});

		// If the multishipping mode is off assure us the checkbox "I want to specify a delivery address for each products I order." is unchecked.
		$('#multishipping_mode_checkbox').attr('checked', false);
		// If the multishipping mode is on, check the box "I want to specify a delivery address for each products I order.".
		if (typeof(multishipping_mode) !== 'undefined' && multishipping_mode)
		{
			$('#multishipping_mode_checkbox').click();
			$('.addressesAreEquals').hide().find('input').attr('checked', false);
		}
		if (typeof(open_multishipping_fancybox) !== 'undefined' && open_multishipping_fancybox)
			$('#link_multishipping_form').click();

		//ADDRESS
		if (typeof formatedAddressFieldsValuesList !== 'undefined')
			updateAddressesDisplay(true);

		$(document).on('change', 'select[name=id_address_delivery], select[name=id_address_invoice]', function(){
			updateAddressesDisplay();
			if (typeof opc !=='undefined' && opc)
				updateAddressSelection();
		});
		$(document).on('click', 'input[name=same]', function(){
			updateAddressesDisplay();
			if (typeof opc !=='undefined' && opc)
				updateAddressSelection();
		});


		//STATE MANAGEMENT
		setCountries();
		bindStateInputAndUpdate();
		if (typeof bindUniform !=='undefined')
			bindUniform();
		bindZipcode();
		bindCheckbox();
		$(document).on('click', '#invoice_address', function(e){
			bindCheckbox();
		});

		if( $('.delivery_option.item').length ){
			$('#opc_delivery_methods .warning:first').hide();
		}

		$(document).on('click', '#processInvoiceProAddress', function(e){
			e.preventDefault();
			$('#opc_new_account-overlay, #opc_delivery_methods-overlay, #opc_payment_methods-overlay').fadeIn('slow');

			// Create alias
			$('#alias_invoice').val( $('#firstname_invoice').val() + ' ' + $('#lastname_invoice').val() );

			if( saveAddress('invoice') ){
				window.location.reload();
			}
		});

	}

}

module.exports = initOrder;


// WEBPACK FOOTER //
// ./js/order-opc.js